/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Info from './info';
import DisabledLocation from '@components/location-toast';

import Promisable from '@services/promisable.service';
import http from '@services/http.service';
import { cacheWorkOrderPhotosAndDocuments } from '@services/cache-services/json-manipulation/tasks';
import { getAppDispatch } from '@utilities/dispatch.util';
import { utFormActions } from '@redux/slices/ut-forms-data';
import style from './style.module.scss';

const AdditionalDataDownloadModal = ({
  isOpen,
  closeModalEvent,
  listOfSelectedTaskThatHaveUTSection = [],
  isDisabledAdditionalDataBtn = false
}) => {
  let [failedCMLEqId, setFailedCMLEqId] = useState([]);
  const [progressLoading, setProgressLoading] = useState(0);
  const [downloadingStatus, setDownloadingStatus] = useState({
    start: false,
    failed: false,
    offline: false,
    completed: false
  });

  useEffect(() => {
    return () => {
      setProgressLoading(0);
      setDownloadingStatus({
        start: false,
        failed: false,
        offline: false,
        completed: false
      });
    };
  }, []);
  const dispatch = getAppDispatch();

  const utFormDataOfInspection =
    useSelector((state) => state.utFormData.utFormDataOfInspection) || {};

  useEffect(() => {
    if (isDisabledAdditionalDataBtn) {
      setDownloadingStatus({
        start: false,
        failed: false,
        offline: true,
        completed: false
      });
    } else {
      startDownloadingDataEvent({ retry: false });
    }
    // if (navigator.onLine)
    // else
    //   setDownloadingStatus({
    //     start: false,
    //     failed: false,
    //     offline: true,
    //     completed: false
    //   });
  }, [listOfSelectedTaskThatHaveUTSection, isDisabledAdditionalDataBtn]);

  if (!isOpen) {
    return;
  }

  const cancelDownloadingDataEvent = () => {
    setDownloadingStatus({
      start: false,
      failed: true,
      offline: false,
      completed: false
    });
  };

  const startDownloadingDataEvent = async ({ retry = false }) => {
    try {
      dispatch?.(utFormActions.setUTFormLoading(true));

      setProgressLoading(0);

      setDownloadingStatus({
        start: true,
        failed: false,
        offline: false,
        completed: false
      });
      let equipmentInspectionMap = {};

      let newListOfSelectedTaskThatHaveUTSection =
        retry && failedCMLEqId?.length
          ? listOfSelectedTaskThatHaveUTSection?.filter((x) =>
              failedCMLEqId.includes(x?.equipmentId)
            )
          : listOfSelectedTaskThatHaveUTSection;

      const uniqueEquipmentIds = newListOfSelectedTaskThatHaveUTSection?.reduce((acc, curr) => {
        if (!acc?.includes(curr?.equipmentId)) {
          acc.push(curr.equipmentId);

          equipmentInspectionMap = {
            ...equipmentInspectionMap,
            [curr.equipmentId]: [curr?.inspectableItemId]
          };
        } else {
          equipmentInspectionMap = {
            ...equipmentInspectionMap,
            [curr.equipmentId]: [
              ...equipmentInspectionMap[curr.equipmentId],
              curr?.inspectableItemId
            ]
          };
        }

        return acc;
      }, []);

      setProgressLoading(1);

      http.setJWT();

      const photosList = [];
      const documentsList = [];
      let cmlDataList = [];
      let copyFailedCMLEqId = [];

      // Todo 1: get single data

      const params = uniqueEquipmentIds.map((id) => `equipmentIds=${id}`).join('&');
      const queryString = `?${params}`;

      const [response, error] = await Promisable.asPromise(http.get(`/EquipmentCML${queryString}`));

      setProgressLoading(2);

      if (error) {
        throw new Error('error');
      }

      const { data = [], status } = response || {};

      if (status == 200 && data?.length > 0) {
        let listOfDataThatStoreOnRedux = {};
        for (let cmlData of data) {
          let photos = cmlData?.photos || [];
          let documents = cmlData?.documents || [];

          const inspectionIds = equipmentInspectionMap[cmlData?.equipmentId];

          for (let inspectionId of inspectionIds) {
            listOfDataThatStoreOnRedux = {
              ...utFormDataOfInspection,
              ...listOfDataThatStoreOnRedux,
              [inspectionId]: [{ ...cmlData, imagesFailed: false }]
            };
            dispatch?.(utFormActions.setUTFormData(listOfDataThatStoreOnRedux));
          }

          if (documents?.length > 0 || photos?.length > 0) {
            try {
              await cacheWorkOrderPhotosAndDocuments({
                cmlDocuments: documents,
                cmlPhotos: photos,
                isCML: true,
                throwError: true
              });
              // throw new Error('dsds');
            } catch (err) {
              console.log('images failed');

              for (let inspectionId of inspectionIds) {
                listOfDataThatStoreOnRedux = {
                  ...utFormDataOfInspection, // original value
                  ...listOfDataThatStoreOnRedux, // existing value
                  [inspectionId]: [{ ...cmlData, imagesFailed: true }]
                };
                dispatch?.(utFormActions.setUTFormData(listOfDataThatStoreOnRedux));
              }

              copyFailedCMLEqId = [...failedCMLEqId];
              copyFailedCMLEqId.push(cmlData.equipmentId);
              setFailedCMLEqId(copyFailedCMLEqId);
            }
          }
        }
      }

      setProgressLoading(3);

      console.log({ copyFailedCMLEqId });
      if (copyFailedCMLEqId?.length) {
        throw new Error('some cml images are not cached..');
      } else {
        setTimeout(() => {
          setProgressLoading(4);
          setDownloadingStatus({
            start: false,
            failed: false,
            offline: false,
            completed: true
          });
        }, 3000);

        setTimeout(() => {
          closeModalEvent({ isFormWrapper: true });
          dispatch?.(utFormActions.setUTFormLoading(false));
        }, 5000);
      }
    } catch (error) {
      console.log({ error });

      !navigator.onLine
        ? setDownloadingStatus({
            start: false,
            failed: false,
            offline: true,
            completed: false
          })
        : setDownloadingStatus({
            start: false,
            failed: true,
            offline: false,
            completed: false
          });
    }
  };

  const getUMLDataAgain = () => {
    startDownloadingDataEvent({ retry: true });
  };
  // console.log({ downloadingStatus });
  return (
    <div>
      {!downloadingStatus?.completed && (
        <Info
          openDownloadModal={isOpen}
          setOpenDownloadModal={closeModalEvent}
          progressLoading={progressLoading}
          cancelDownloadingDataEvent={cancelDownloadingDataEvent}
          downloadingStatus={downloadingStatus}
          getUMLDataAgain={getUMLDataAgain}
        />
      )}

      {downloadingStatus?.completed && (
        <DisabledLocation
          className={style.toastStyles}
          text="Success! Additional data downloaded"
          showLocationDisabledInfo={true}
        />
      )}
    </div>
  );
};

export default AdditionalDataDownloadModal;
